class QhPlano {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.ano = dados ? dados.ano : null;
    this.numero = dados ? dados.numero : null;
    this.dataInicio = dados ? dados.dataInicio : null;
    this.dataFim = dados ? dados.dataFim : null;
    this.ativo = dados ? dados.ativo : true;
    this.descricao = dados ? dados.descricao : null;
    this.ativoStr = dados
      ? dados.ativo === true
        ? "Sim"
        : "Não"
      : "Sim";
  }

  static validations(required, integer, maxLength, dataFimMenor) {
    return {
      ano: { required, integer },
      numero: { required, integer },
      dataInicio: { required },
      dataFim: { required, dataFimMenor: dataFimMenor("dataInicio") },
      descricao: { required, maxLength: maxLength(100) }
    };
  }

  static validationMessages() {
    return {
      ano: {
        required: "Ano é obrigatório",
        integer: "Ano deve ser um número inteiro"
      },
      numero: {
        required: "Número é obrigatório",
        integer: "Número deve ser um número inteiro"
      },
      dataInicio: {
        required: "Data Início é obrigatório"
      },
      dataFim: {
        required: "Data Fim é obrigatório",
        dataFimMenor: "Data Fim não pode ser menor que a Data Início"
      },
      descricao: {
        required: "Descrição é obrigatória",
        maxLength: "Descrição só aceita no máximo 100 caracteres"
      }
    };
  }
}
export default QhPlano;
